import { render, staticRenderFns } from "./LicenseFile.vue?vue&type=template&id=a9f30d14&scoped=true&"
import script from "./LicenseFile.vue?vue&type=script&lang=js&"
export * from "./LicenseFile.vue?vue&type=script&lang=js&"
import style0 from "./LicenseFile.vue?vue&type=style&index=0&id=a9f30d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f30d14",
  null
  
)

export default component.exports